import React, { useEffect, useRef } from 'react';

const OPTION_LABELS = {
  AUTO: 'AUTO SWITCH (EVERY 1 MIN)',
  MANUAL: 'MANUAL SWITCH',
};

function OptionsView({
  animating,
  closeOptions,
  isOpen,
  options,
  selected,
  selectOption,
  toggleOptions,
}) {
  const optionsRef = useRef(null);
  const showAllSelected = selected.display === 'SHOW ALL';

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (optionsRef.current?.contains(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
      closeOptions();
    };

    document.addEventListener('click', handleOutsideClick, true);
    return () => document.removeEventListener('click', handleOutsideClick, true);
  }, [closeOptions, isOpen]);

  return (
    <>
      <button
        className={`options-backdrop ${isOpen ? 'options-backdrop-visible' : ''}`}
        type="button"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          closeOptions();
        }}
        aria-label="close view settings"
      />
      <nav
        ref={optionsRef}
        className={`header-options ${isOpen ? 'options-expanded' : ''}`}
      >
        <div className="options-island-title">Sequence settings</div>
        <button
          className="options-island-toggle"
          type="button"
          onClick={toggleOptions}
          aria-expanded={isOpen}
          aria-label={isOpen ? 'close options' : 'open options'}
        >
          <span className="options-island-handle" aria-hidden="true">
            {isOpen ? (
              <span className="options-close-icon" />
            ) : (
              <>
                <span className="options-menu-dot" />
                <span className="options-menu-dot" />
                <span className="options-menu-dot" />
              </>
            )}
          </span>
        </button>
        {options.map((group) => {
          const isGroupDisabled = showAllSelected && group.id !== 'display';

          return (
            <div key={group.id} className={`option-group ${isGroupDisabled ? 'disabled' : ''}`}>
              <span className="option-group-label">{group.label}</span>
              {group.options.map((option) => {
                const isActive = !isGroupDisabled && selected[group.id] === option;
                const animation = animating[group.id];

                return (
                  <div
                    key={option}
                    className={`option-item ${isActive ? 'active' : 'inactive'} ${isGroupDisabled ? 'disabled' : ''}`}
                    onClick={() => selectOption(group.id, option)}
                    aria-disabled={isGroupDisabled}
                  >
                    <span
                      className={`dot ${isActive ? 'visible' : 'hidden'} ${animation?.to === option ? 'expand' : ''} ${animation?.from === option ? 'shrink' : ''}`}
                    />
                    {OPTION_LABELS[option] || option}
                  </div>
                );
              })}
            </div>
          );
        })}
      </nav>
    </>
  );
}

export default OptionsView;
